/* eslint-disable */
export default {
  hide: '隐藏',
  end: '结束',
  keypad: '拨号键盘',
} as const;

// @key: @#@"hide"@#@ @source: @#@"Hide"@#@
// @key: @#@"end"@#@ @source: @#@"End"@#@
// @key: @#@"keypad"@#@ @source: @#@"Keypad"@#@
